import BottomTabs from '@/components/common/BottomTabs';
import Header from '@/components/common/Header';
import { Footer } from '@/components/footer';
import Sidebar from '@/components/home/Sidebar';
import BgUi from '@/components/ui/BgUi';
import { cn } from '@/utils';
import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
export default function AppShell() {
  const [toggleSidebar, setToggleSidebar] = useState(false);
  const location = useLocation();
  const hideBottomTabsRoutes = ['/live-match', '/quiz-play', '/live-match', '/quiz/play'];
  const hideFooter = ['/live-match'];
  const shouldHideBottomTabs = hideBottomTabsRoutes.some((route) =>
    location.pathname.startsWith(route)
  );
  const shouldShowFooter = hideFooter.some((route) => location.pathname.startsWith(route));
  return (
    <div className="shell relative isolate">
      <BgUi />
      {toggleSidebar && <Sidebar setToggle={setToggleSidebar} />}
      <Header setToggle={setToggleSidebar} />
      <main className={cn('shell-content mt-[50px] z-10', !shouldHideBottomTabs && 'pb-[64px]')}>
        <Outlet />
        {!shouldShowFooter && <Footer />}
      </main>
      {!shouldHideBottomTabs && <BottomTabs />}
    </div>
  );
}
